module.exports = __webpack_public_path__ + "static/media/16.82f5f10a.png";